import { RouteConfig } from 'vue-router';

import { Rules as CaslRules } from '../../../back/src/casl/casl.constants';

import FornecedoresSapIndex from '@/pages/fornecedores-sap/FornecedoresSapIndex.vue';

const routes: RouteConfig[] = [
  {
    path: '/fornecedores',
    name: 'FornecedoresSapIndex',
    component: FornecedoresSapIndex,
    meta: {
      icon: 'mdi-account-multiple',
      rules: [CaslRules.FornecedorSap.listar],
    },
  },
];

export default routes;
